import type { BranchLocation } from './types';
import generateUUID from '../../utils/generateUUID';

const ROOT_NODE_ID = generateUUID();
const ROOT_NODE: BranchLocation = {
  id: ROOT_NODE_ID,
  name: 'root',
  locationLevel: 0,
  path: '',
  children: [],
};

export default ROOT_NODE;
